<template>
  <div class="app-footer-copyright">
    <div class="footer-copyright-container">
      <span class="description">
        Solfacil Energia Solar Tecnologia e Serviços Financeiros Ltda. CNPJ:
        31.931.053/0001-50, Rua Cardeal Arcoverde, 2.450, 5° andar, cjs. 501 a
        511, Pinheiros, São Paulo/SP, CEP: 05.408-003. <br />Todas as imagens
        contidas neste site são meramente ilustrativas. Copyright © Solfácil.
        (Lei 9610 de 19/02/1998)
      </span>
      <img src="/icons/brand.svg" alt="brand" class="icon-brand" />
    </div>
  </div>
</template>

<style lang="scss">
  @mixin site-container {
    @apply w-full md:site:max-w-[1440px];
    @apply md:site:mx-auto;
  }

  .app-footer-copyright {
    @apply w-full flex flex-col md:site:flex-row gap-xs;
    @apply px-micro md:site:px-0 py-2xs;
    @apply bg-neutral-high-pure;

    > .footer-copyright-container {
      @apply flex flex-col md:site:items-center md:site:flex-row gap-4xs md:site:justify-between;
      @apply md:site:px-2xs;
      @include site-container;

      > .description {
        @apply fonts-body-small-regular;
        @apply text-neutral-low-light;
      }

      > .icon-brand {
        @apply icon-size-large;
      }
    }
  }
</style>
